import { AppThunk } from '@legacyApp/types/store/ThunkAction';
import { DropdownContentData } from '@legacyApp/client/store/dropdown/dropdown.reducer';

export const dropdownGetThunk = (id: string): AppThunk<DropdownContentData> => {
	return (dispatch, getState) => {
		const state = getState();
		return state.dropdown.content[id];
	};
};
